/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/credentialLists.config.json';
import axios from 'axios';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_MY_CREDENTIAL_LIST } from '../graphql';
import { VApplication } from '../../../application';
import { useCredential } from '../../../pages/SelfAttestedCredentialReviewList/provider';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface ICredentialListsMethods extends IPluginMethodMap {
  getCredentialListsProps(args: any): Promise<any>;
}

export interface IGetCredentialListProps {
  offset?: number;
  size?: number;
  criteria?: any;
}

export class CredentialListsService implements IAgentPlugin {
  readonly methods: ICredentialListsMethods;

  constructor() {
    this.methods = {
      getCredentialListsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialListProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    const credential = useCredential();
    console.log('crededede', credential);
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_CREDENTIAL_LIST,
          variables: {
            input: {
              criteria: {
                // verifyStatus: "UNDER_REVIEW",
                state: 'UNDER_REVIEW',
                selfAttested: true,
                // schemaRef: "dc69b9ee-120f-4573-a1fc-602201a7f51d-v1",
                schemaRef: credential.userId,
              },
              offset: 0,
              size: 10,
            },
          },
          fetchPolicy: 'network-only',
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatCredentialTable(
            res?.data?.getMyCredentials?.data
          );
          console.log('rowdata->', _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getMyCredentials?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getMyCredentials?.currentPage,
            pageSize: res?.data?.getMyCredentials?.pageSize,
            totalCount: res?.data?.getMyCredentials?.totalCount,
            totalPages: res?.data?.getMyCredentials?.totalPages,
          };
        }
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
  }

  private formatCredentialTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          id: item?.id,
          name: `${item?.to}`,
          // image:item?.image,
          credential: item?.name,
          email: item?.email,
        };
      });
    return _rowData;
  }
  // return { ...(config || {}) };
}
